import type {ParserT} from '@freckle/parser'
import {Parser, record, merge, array, number} from '@freckle/parser'
import type {Word} from '@freckle/educator-entities/ts/ela/word-study/logic/word-study-question-types'
import {parseWord} from '@freckle/educator-entities/ts/ela/word-study/logic/word-study-question-types'
import type {WordStudyQuestionCommonAttrs} from '@freckle/educator-entities/ts/ela/word-study/models/word-study-question'
import {parseWordStudyQuestionCommonAttrs} from '@freckle/educator-entities/ts/ela/word-study/models/word-study-question'

type WordStudySortingQuestionCorrectAnswer = {
  indexes: Array<Array<number>>
}

export type WordStudyAnswerSorting = Array<Array<string>>

type WordStudySortingQuestionExtraAttrs = {
  answers: Array<Word>
  correctAnswers: WordStudySortingQuestionCorrectAnswer
  bucketFieldNames: Array<Word>
}

export type WordStudySortingQuestionAttrs = WordStudyQuestionCommonAttrs &
  WordStudySortingQuestionExtraAttrs

const parseWordStudySortingQuestionExtraAttrs: ParserT<WordStudySortingQuestionExtraAttrs> = record(
  {
    answers: array(parseWord),
    correctAnswers: record({indexes: array(array(number()))}),
    bucketFieldNames: array(parseWord),
  },
)

const parseWordStudySortingQuestionAttrs: ParserT<WordStudySortingQuestionAttrs> = merge(
  parseWordStudySortingQuestionExtraAttrs,
  parseWordStudyQuestionCommonAttrs,
)

export const parseWordStudySortingQuestion = Parser.mkRun<WordStudySortingQuestionAttrs>(
  parseWordStudySortingQuestionAttrs,
)
